import { BoxBackgrounds } from '@components/atoms/Box/Box'

import { Button, GridCard, GridSection } from '@definitions/types/storyblokTypes'

import { createStoryblokAsset } from '../../../../../__mocks__/storyblok/createStoryblokAsset'
import { createStoryblokMultilink } from '../../../../../__mocks__/storyblok/createStoryblokMultilink'
import { createStoryblokRichtext } from '../../../../../__mocks__/storyblok/createStoryblokRichtext'

/**
 * Creates a mock Button for GridCard
 */
function createGridCardButton(overrides: Partial<Button> = {}): Button {
  return {
    _uid: '110aa19f-6a68-4063-8f37-c759c276b14b',
    link: createStoryblokMultilink({
      linktype: 'story',
    }),
    size: 'medium',
    label: 'Button label',
    style: 'default',
    component: 'button',
    button_color: 'primary',
    _editable:
      '<!--#storyblok#{"name": "button", "space": "235453", "uid": "110aa19f-6a68-4063-8f37-c759c276b14b", "id": "322564270"}-->',
    ...overrides,
  }
}

/**
 * Creates a mock GridCard for GridSection
 */
function createGridCardItem(overrides: Partial<GridCard> = {}): GridCard {
  return {
    _uid: '6858dbc6-05f6-4350-8c4c-069481025880',
    icon: createStoryblokAsset({
      id: 678345,
      alt: 'null',
      filename: 'https://a.storyblok.com/f/235453/678345/icon.png',
      src: 'https://a.storyblok.com/f/235453/678345/icon.png',
      width: 100,
      height: 100,
      aspect_ratio: 1,
      content_type: 'image/png',
      updated_at: '2024-01-01T00:00:00.000Z',
    }),
    text: createStoryblokRichtext('qwer'),
    label: 'asdf',
    button: [createGridCardButton()],
    component: 'grid-card',
    background_color: BoxBackgrounds.WHITE,
    _editable:
      '<!--#storyblok#{"name": "grid-card", "space": "235453", "uid": "6858dbc6-05f6-4350-8c4c-069481025880", "id": "322564270"}-->',
    ...overrides,
  }
}

/**
 * Creates a mock GridSection
 * @param overrides - Partial fields to override defaults
 * @returns Complete GridSection mock
 */
export function createGridSection(
  overrides: Partial<GridSection> = {}
): GridSection {
  return {
    _uid: '18c2604f-4815-4447-b580-70b6250c9e64',
    cols: '3',
    lead: '',
    cards: [
      createGridCardItem(),
      createGridCardItem({
        _uid: 'dc9ac645-0e69-4843-88e9-e7730de2cd6d',
        background_color: BoxBackgrounds.SECONDARY,
        label: 'qwer',
      }),
      createGridCardItem({
        _uid: 'b67a300a-5273-4529-82fe-15f320c539ca',
        background_color: BoxBackgrounds.GREY,
        label: 'asdf',
        icon: createStoryblokAsset({
          id: 2345,
          alt: '§',
          filename: 'https://a.storyblok.com/f/235453/2345/icon.png',
          src: 'https://a.storyblok.com/f/235453/2345/icon.png',
          width: 100,
          height: 100,
          aspect_ratio: 1,
          content_type: 'image/png',
          updated_at: '2024-01-01T00:00:00.000Z',
        }),
        text: createStoryblokRichtext('asdf'),
      }),
    ],
    headline: '',
    component: 'grid-section',
    _editable:
      '<!--#storyblok#{"name": "grid-section", "space": "235453", "uid": "18c2604f-4815-4447-b580-70b6250c9e64", "id": "322564270"}-->',
    ...overrides,
  }
}
